import React, {useContext} from 'react';
import EpmrConfigsListing from './EpmrConfigsListing';
import { RolePermissions, PermissionContext } from '../../../../../../appContext';
import { pages } from '../../../common/constant';
import { PermisionDenied } from '../../../common/commonComponents';

const EpmrConfiguration = () => {

    const userPermissions = RolePermissions(useContext(PermissionContext), pages['epmrConfigs']['id']);
    return (
        userPermissions
            ? <EpmrConfigsListing userPermissions={userPermissions}/>
            : <PermisionDenied />
    );
}

export default EpmrConfiguration;